export const styles = (theme) => ({
    root: {
        width: '100%',
        height: '100%',
        borderRadius: '6px',
        overflow: 'hidden',
    },
});

export default styles;
